import React, {FC} from 'react';
import cn from 'classnames';
import styles from './Radio.css';

export type RadioProps = Omit<
	React.DetailedHTMLProps<React.InputHTMLAttributes<HTMLInputElement>, HTMLInputElement>,
	'ref' | 'type'
>;

export const Radio: FC<RadioProps> = props => {
	const {className, ...proxyProps} = props;
	return <input className={cn(styles.root, className)} type='radio' {...proxyProps} />;
};

Radio.displayName = 'Radio';
